import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { Web3Providers } from "@/web3Config";
import { GoogleOAuthProvider } from "@react-oauth/google";

// Defensive guard: My Kind no longer uses any crypto wallet. If the MetaMask (or any web3)
// browser extension injects and throws "Failed to connect to MetaMask", swallow it so it
// can never surface as a runtime-error overlay or crash the app.
if (typeof window !== "undefined") {
  const isWalletNoise = (s) =>
    typeof s === "string" && /metamask|inpage\.js|failed to connect to metamask|ethereum|web3/i.test(s);
  window.addEventListener(
    "error",
    (e) => {
      if (isWalletNoise(e?.message) || isWalletNoise(e?.error?.message) || isWalletNoise(e?.filename)) {
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    },
    true
  );
  window.addEventListener(
    "unhandledrejection",
    (e) => {
      const msg = e?.reason?.message || (typeof e?.reason === "string" ? e.reason : "");
      if (isWalletNoise(msg)) {
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    },
    true
  );
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const root = ReactDOM.createRoot(document.getElementById("root"));
const tree = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Web3Providers>
        <App />
      </Web3Providers>
    </QueryClientProvider>
  </React.StrictMode>
);
root.render(
  GOOGLE_CLIENT_ID ? <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>{tree}</GoogleOAuthProvider> : tree,
);
